import React, { useState, Fragment } from 'react'
import styled, { css } from 'react-emotion'
import { useBooking } from '../bookingContext'
import { colors } from '../../styles'
import { Svg, UserIcon, ga } from '../../application'
import { Modal } from '../../application'
import ManageUsers from './ManageUsers'

import getText from '../strings'

const Flex = styled('div')`
  display: flex;
  cursor: pointer;
`

const InviteIcon = styled('div')`
  display:none;
  background-color: ${colors.tui_dark_blue};
  border: 1px solid ${colors.tui_white};
  border-radius: 50px;
  color: ${colors.tui_white};
  width: 38px;
  height: 38px;

  svg.pictogram-plus {
    width: 30px;
    height: 30px;
    margin: 3px;
  }

  svg.pictogram-share {
    width: 24px;
    height: 24px;
    margin: 6px;
  }

  @media (max-width: 767px) {
    display:unset;
  }
`

const InviteButton = styled('button')`
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;

  svg.pictogram-plus {
    width: 22px;
    height: 22px;
    margin-right: 4px;
  }

  svg.pictogram-share {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }

  @media (max-width: 767px) {
    display:none;
  }
`

const InviteUsers = ({ onInviteUpdate, onRevokeInvite }) => {
  const bookingData = useBooking()
  const [modalOpen, setModalOpen] = useState(false)

  const open = () => {
    ga.buttonClick('share-booking-modal-open')
    setModalOpen(true)
  }
  const close = () => {
    ga.buttonClick('share-booking-modal-close')
    setModalOpen(false)
  }

  if (!bookingData.connectedUsers) {
    return null
  }

  let users = bookingData.connectedUsers.filter(user => user.invitationExist || user.leadPassenger)

  if (users.length > 2)
    users = [users[0], { firstName: '+', lastName: (users.length - 1).toString() }]

  return (
    <Fragment>
      {bookingData.connectedUsers.length > 1 && <Flex onClick={open}>
        {users.length > 1 && users.map((user, index) => <UserIcon key={index} accepted={!!user.invitationAccepted} {...user} />)}
        <InviteButton className='btn btn-sm btn-function'>
          <Svg icon='plus' />
          {getText('buttons', 'invite')}
        </InviteButton>
        <InviteIcon>
          <Svg icon='plus' />
        </InviteIcon>
      </Flex>}
      <Modal open={modalOpen} onClose={close}>
        <ManageUsers
          onInviteUpdate={onInviteUpdate}
          onRevokeInvite={onRevokeInvite} />
      </Modal>
    </Fragment>
  )
}

export default InviteUsers
